// Copyright ©️ 2026 eVolve MEP, LLC

import { useMediaQuery } from '@mantine/hooks';

/**
 * `true` on viewports `< 600px`, where the app swaps to the mobile shell and unsupported pages fall
 * back to a restricted view.
 */
export const useIsMobile = () =>
  useMediaQuery('(max-width: 599px)', false, {
    /*
     * `getInitialValueInEffect: false` makes the first render read `matchMedia` synchronously.
     * Without it, every newly mounted consumer reports desktop (`false`) for its first paint and
     * corrects itself in an effect — which briefly mounts the desktop view when navigating to a page on
     * mobile, appearing as a full-page flash.
     */
    getInitialValueInEffect: false,
  });
